import * as React from 'react';
import {
	Edit,
	EditProps,
	NumberInput,
	SimpleForm,
	TextInput
} from 'react-admin';

export const TagEdit = (props: EditProps): React.ReactElement => {
	return (
		<Edit {...props} undoable={false}>
			<SimpleForm>
				<NumberInput step={1} source="id" label="#" disabled/>
				<TextInput step={1} source="title" label="TITLE"/>
			</SimpleForm>
		</Edit>
	);
};
